import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

const LOCALE_ROOT = "paywall_checkout.form.email_verification_states.otp_state";

interface ResendCodeSectionProps {
  isResending?: boolean;
  isSubmitting?: boolean;
  onResendClick: () => void;
}

export const ResendCodeSection = ({
  isSubmitting = false,
  isResending = false,
  onResendClick,
}: ResendCodeSectionProps) => (
  <div>
    {`${t([LOCALE_ROOT, "did_not_receive_code"])} `}
    <Button
      type="button"
      variant="link"
      onClick={onResendClick}
      className="!h-auto !p-0 underline"
      disabled={isSubmitting || isResending}
    >
      <Typography.LabelSm weight="normal">
        {isResending
          ? t([LOCALE_ROOT, "sending"])
          : t([LOCALE_ROOT, "resend_code"])}
      </Typography.LabelSm>
    </Button>
  </div>
);
